import React from 'react';
import General from '../../components/Help/General';

const GeneralPage = () => {
  return <General />;
};

export default GeneralPage;
